import {Model} from "@vuex-orm/core";

export default class WebsitePackageCountry extends Model {

    static entity = 'websitePackageCountry';

    static primaryKey = ['website_package_id', 'country_id'];

    static fields () {
        return {
            website_package_id: this.number(null).nullable(),
            country_id: this.number(null).nullable(),
        }
    }
}
